import axios from '../utilities/Axios';

export default {
  cancelLessonItem: async (id) => (await axios.delete(`/booking/cancel/${id}`)).data.data,
  getStudentLessons: async () => (await axios.get(`/lessons`)).data.data,
}